import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";


// Requests
export class ReservationSettingsSyncModel extends SyncModel {
}

export class ReservationBasketSyncModel extends SyncModel {
  public token: string;
  public hash: string;
}

// Responses

/** Only one ReservationSettings exists and it has the id=0 (this const is used for selecting the ReservationSettings) */
export const ReservationSettingsDMKey: number = 0;

export class ReservationSettingsDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;
  public locations: number[];
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
  public change_by: number;
}

export class ReservationSettingsSyncDataModel extends SyncDataModel {
  public settings: ReservationSettingsDataModel[];
  public get models(): DataModel[] { return this.settings; }
  public DeserializeType(): void {
    this._DeserializeType(ReservationSettingsDataModel);
  }
}

export class ReservationBasketSyncDataModel extends SyncDataModel {
  public basket: ReservationBasketDataModel[];
  public get models(): DataModel[] { return this.basket; }
  public DeserializeType(): void {
    // No Complex Types
    //this._DeserializeType(ReservationBasketDataModel);
  }
}

export class ReservationBasketDataModel extends DataModel {
  public get DM_Key(): string | number {
    return 0; // Not used for actual syncing
  }
  public token: string;
  public location: number;
  public change_at_ymd: number;
  public change_at_hms: number;
  public change_by: number;
  public comment: string;
  public urlTrue: string;
  public urlFalse: string;
  public urlBasket: string;
  public items: ReservationBasketArticleDataModel[];

  public DeserializeSubTypes(): void {
    // No Complex Types

    // const me = this;
    // if (Array.isArray(me.items)) {
    //   const items = me.items;
    //   for (let i = 0; i < items.length; ++i) {
    //     const item = items[i];
    //     if (Object.getPrototypeOf(item) !== ReservationBasketArticleDataModel) {
    //       items[i] = Utils.GetExtend(new ReservationBasketArticleDataModel(), item);
    //     }
    //   }
    // }
  }
}

export class ReservationBasketArticleDataModel {
  public id: number;
  public productId: number;
  public count: number;
  public comment: string;
  public variable_price: number;
  public valid_date_ymd: number;
  public valid_time_hms: number;
}
